/**
 * @function axboot.gridBuilder
 * @param {Object} _config
 * @example
 * ```js
 * this.target = axboot.gridBuilder({
 *    showLineNumber: false,
 *    showRowSelector: false,
 *    frozenColumnIndex: 0,
 *    target: $('[data-ax5grid="grid-view-01"]'),
 *    columns: [
 *        //menuId
 *        {key: "grpAuthCd", label: "권한그룹코드", width: 80, align: "center"},
 *        {key: "grpAuthNm", label: "권한그룹명", width: 160, align: "left"},
 *        {key: "useYn", label: "권한적용", editor: "checkYn"},
 *        {key: "schAh", label: "조회", width: 50, align: "center", editor: "menu-program-auth-checkYn"},
 *        /// --> 이것들을 list로 담아서  [PUT] "/api/v2/menu/auth"
 *    ],
 *    body: {
 *        onClick: function () {
 *            // this.self.select(this.dindex);
 *        }
 *    }
 * });
 * ```
 */
axboot.gridBuilder = function () {
    var defaultGridConfig = {
        showLineNumber: true,
        lineNumberColumnWidth: 50,
        rowSelectorColumnWidth: 28,
        header: {
            align: 'center',
            columnHeight: 30
        },
        body: {
            columnHeight: 30
        },
        page: {
            navigationItemCount: 9,
            height: 30,
            display: true,
            firstIcon: '<i class="cqc-controller-jump-to-start"></i>',
            prevIcon: '<i class="cqc-triangle-left"></i>',
            nextIcon: '<i class="cqc-triangle-right"></i>',
            lastIcon: '<i class="cqc-controller-next"></i>'
        },
        tree: {
            use: false,
            indentWidth: 20,
            arrowWidth: 15,
            iconWidth: 18,
            icons: {
                openedArrow: '<i class="fa fa-caret-down" aria-hidden="true"></i> ',
                collapsedArrow: '<i class="fa fa-caret-right" aria-hidden="true"></i> ',
                groupIcon: '<i class="fa fa-folder-open" aria-hidden="true"></i> ',
                collapsedGroupIcon: '<i class="fa fa-folder" aria-hidden="true"></i> ',
                itemIcon: '<i class="fa fa-circle" aria-hidden="true"></i> '
            }
        }
    };

    return function (_config, gridView) {
        var myGridConfig = $.extend(true, {}, defaultGridConfig, _config);

        myGridConfig.page.onChange = function () {
            if (gridView != undefined && gridView != null) {
                gridView.setPageNo(this.page.selectPage);
            }

            // 2018.06.25 (이상훈) : myGridConfig.onPageChange 구현 메소드 안에서 this 를 사용할 수 있도록 수정.
            //myGridConfig.onPageChange(this.page.selectPage);
            myGridConfig.onPageChange.call(this, this.page.selectPage);
        };

        if (!myGridConfig.body.onDBLClick) {
            myGridConfig.body.onDBLClick = function () {
                this.self.select(this.dindex, { selectedClear: true });

                var rowItem = this.list[this.dindex];

                if (!ax5.util.isNothing(myGridConfig.onItemDblClick) && ax5.util.isFunction(myGridConfig.onItemDblClick)) {
                    //myGridConfig.onItemDblClick(rowItem);

                    // 2018.06.25 (이상훈) : myGridConfig.onItemDblClick 구현 메소드 안에서 this 를 사용할 수 있도록 수정.
                    myGridConfig.onItemDblClick.call(this, rowItem);
                }
            };
        }

        // 사용자 정의시 body.onClick 이 없을 경우 설정
        if (!myGridConfig.body.onClick) {
            myGridConfig.body.onClick = function () {
                // 20180625 (이상훈) : tree 를 사용중이 아닐 경우에만 행전체 선택을 실행합니다. tree 일 경우 selectedClear 에서 오류 발생
                if (this.self.config.tree.use) {
                    var prevModified;

                    for (var i = 0; i < this.self.list.length; i++) {
                        if (!this.self.list[i].hasOwnProperty('__modified__')) {
                            this.self.setValue(i, '__modified__', false);
                        }

                        if (i != this.dindex) {
                            prevModified = this.self.list[i]['__modified__'];

                            this.self.setValue(i, '__selected__', false);
                            this.self.setValue(i, '__modified__', prevModified);
                        }
                    }

                    this.self.select(this.dindex);
                } else {
                    // selectedClear : 다중 선택한 후 단일행 클릭시 이전 다중행 선택 해제됨.
                    this.self.select(this.dindex, { selectedClear: true });
                }

                var rowItem = this.list[this.dindex];

                // 바인딩
                axboot.util.bindingTarget(this.self.$target, rowItem);

                if (!ax5.util.isNothing(myGridConfig.onItemClick) && ax5.util.isFunction(myGridConfig.onItemClick)) {
                    var cellInfo = {
                        colIndex : this.colIndex,
                        dindex   : this.dindex,
                        doindex  : this.doindex,
                        column   : this.column,
                        rowIndex : this.rowIndex
                    };

                    // 2018.06.25 (이상훈) : myGridConfig.onItemClick 구현 메소드 안에서 this 를 사용할 수 있도록 수정.
                    //myGridConfig.onItemClick(rowItem, cellInfo, this.self);
                    myGridConfig.onItemClick.call(this, rowItem, cellInfo, this.self);
                }
            };
        }

        if (!myGridConfig.body.onDataChanged) {
            myGridConfig.body.onDataChanged = function () {
                if (!ax5.util.isNothing(myGridConfig.onDataChanged) && ax5.util.isFunction(myGridConfig.onDataChanged)) {
                    // 2018.06.25 (이상훈) : 호출시 메소드 안에서 this 객체가 body.onDataChanged 로 선언할 때와 다름.
                    //myGridConfig.onDataChanged(this.dindex, this.key, this.value, this.item, this.self);

                    // 2018.06.25 (이상훈) : myGridConfig.onDataChanged 구현 메소드 안에서 this 를 사용할 수 있도록 수정.
                    myGridConfig.onDataChanged.call(this, this.dindex, this.key, this.value, this.item, this.self);
                }
            }
        }

        return new ax5.ui.grid(myGridConfig);
    };
}();

//############################################################################################
//# 사용자 정의 그리드 포매터
//############################################################################################

// 개수
ax5.ui.grid.formatter['count'] = function () {
    return this.value + '개';
};

/**
 * Percent (ex. 15%)
 */
ax5.ui.grid.formatter['percent'] = function () {
    return this.value + '%';
};

// 파일 크기
ax5.ui.grid.formatter['fileSize'] = function () {
    return ax5.util.number(this.value, { 'byte' : true });
};

ax5.ui.grid.formatter['dateTime'] = function () {
    return this.value != null ? moment(this.value).format(axboot.def.dateTimeFormat) : '';
};

ax5.ui.grid.formatter['date'] = function () {
    return this.value != null ? moment(this.value).format(axboot.def.dateFormat) : '';
};

ax5.ui.grid.formatter['dateMonth'] = function () {
	return this.value != null ? moment(this.value).format(axboot.def.dateMonthFormat) : '';
};

ax5.ui.grid.formatter['yn'] = function () {
    return this.value == 'Y' ? '<span class="label label-success">YES</span>' : '<span class="label label-danger">NO</span>';
};




ax5.ui.grid.formatter["bizno"] = function () {
    var val = (this.value || "").replace(/\D/g, "");
    var regExpPattern = /^([0-9]{3})\-?([0-9]{1,2})?\-?([0-9]{1,5})?.*$/,
        returnValue = val.replace(regExpPattern, function (a, b) {
        var nval = [arguments[1]];
        if (arguments[2]) nval.push(arguments[2]);
        if (arguments[3]) nval.push(arguments[3]);
        return nval.join("-");
    });
    return returnValue;
};

ax5.ui.grid.formatter["phone"] = function () {
    var val = this.value.replace(/\D/g, "");
    var regExpPattern3 = /^([0-9]{3})\-?([0-9]{1,4})?\-?([0-9]{1,4})?\-?([0-9]{1,4})?\-?([0-9]{1,4})?/,
        returnValue = val.replace(regExpPattern3, function (a, b) {
        var nval = [arguments[1]];
        if (arguments[2]) nval.push(arguments[2]);
        if (arguments[3]) nval.push(arguments[3]);
        if (arguments[4]) nval.push(arguments[4]);
        if (arguments[5]) nval.push(arguments[5]);
        return nval.join("-");
    });
    return returnValue;
};

//시간에서 시,분 구분자 표시
ax5.ui.grid.formatter["time"] = function () {	
	var val = "";
	if( (this.value != null && this.value != "") || this.value == 0) {
		val = this.value.replace(':','');
		return val.substr(0,2)+":"+val.substr(2);
	} else {
		return "";
	}		
};

//넘어오는 값이 0일경우 ""으로 치환되어 0비교 추가
ax5.ui.grid.formatter["money"] = function () {
	if( (this.value != null && this.value != "") || this.value == 0) {
		return ax5.util.number(this.value, {round:0, money:true});
	} else {
		return "";
	}
};

//넘어오는 값이 0일경우 ""으로 치환되어 0비교 추가 (면적 포매터)
ax5.ui.grid.formatter["size"] = function () {
	
	if( (this.value != null && this.value != "") || this.value == 0) {
		return ax5.util.number(this.value, {abs:true, round:2, money:true});
	} else {
		return "";
	}
};


//숮자형 포메터
ax5.ui.grid.formatter["number"] = function () {
	
	if( (this.value != null && this.value != "") || this.value == 0) {
		return ax5.util.number(this.value);
	} else {
		return "";
	}
};